import { theme } from "../../../../styling/theme";

export const getAgeGenderOptions = (
  valuesMale: string[],
  valuesFemale: string[],
  ticksFontSize?: number
) => {
  return {
    responsive: true,
    layout: {
      padding: {
        top: 10,
      },
    },
    plugins: {
      customTicks: {
        borderColor: theme.color.greyColor,
        borderDash: [4, 8],
        valuesFemale: valuesFemale.map(
          (item) => `${Math.round(parseFloat(item) * 10) / 10}%`
        ),
        valuesMale: valuesMale.map(
          (item) => `${Math.round(parseFloat(item) * 10) / 10}%`
        ),
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: ({ formattedValue }: any) => `${formattedValue}%`,
        },
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          display: false,
          callback: (val: any, index: any) => (index % 2 === 0 ? val : null),
        },
        grid: {
          color: theme.color.greyLightColor,
          drawBorder: false,
        },
      },
      x: {
        ticks: {
          font: { weight: "600", size: ticksFontSize ? ticksFontSize : 14 },
          color: theme.color.textGreyColor,
        },
        grid: {
          display: false,
          drawBorder: false,
        },
      },
    },
  };
};

export const customTicksAgeGender = {
  id: "customTicks",
  beforeDraw(chart: any, _: any, options: any) {
    const {
      ctx,
      chartArea: { top, width, height },
    } = chart;

    const valuesFemale = options.valuesFemale;
    const valuesMale = options.valuesMale;
    const part = width / valuesFemale.length / 2;

    ctx.setLineDash(options.borderDash);
    ctx.strokeStyle = options.borderColor;
    ctx.beginPath();

    valuesFemale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.moveTo(currentPart, top);
      ctx.lineTo(currentPart, height + 20);
      ctx.moveTo(currentPart + 17, top);
      ctx.lineTo(currentPart + 17, height + 20);
    });

    ctx.fillStyle = theme.color.textGreyColor;
    ctx.font = "11px sans-serif";
    ctx.textAlign = "right";
    valuesFemale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.fillText(item, currentPart + 7, 8);
    });

    ctx.textAlign = "left";
    valuesMale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.fillText(item, currentPart + 10, 8);
    });

    ctx.stroke();
  },
};

export const customTicksAgeGenderExport = {
  id: "customTicks",
  beforeDraw(chart: any, _: any, options: any) {
    const {
      ctx,
      chartArea: { top, width, height },
    } = chart;

    const valuesFemale = options.valuesFemale;
    const valuesMale = options.valuesMale;
    const part = width / valuesFemale.length / 2;

    ctx.setLineDash(options.borderDash);
    ctx.strokeStyle = options.borderColor;
    ctx.beginPath();

    valuesFemale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.moveTo(currentPart, top);
      ctx.lineTo(currentPart, height + 20);
      ctx.moveTo(currentPart + 17, top);
      ctx.lineTo(currentPart + 17, height + 20);
    });

    ctx.fillStyle = theme.color.textGreyColor;
    ctx.font = "10px sans-serif";
    ctx.textAlign = "right";
    valuesFemale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.fillText(item, currentPart + 7, 8);
    });

    ctx.textAlign = "left";
    valuesMale.forEach((item: any, index: number) => {
      const currentPart = part * (index * 2 + 1);
      ctx.fillText(item, currentPart + 10, 8);
    });

    ctx.stroke();
  },
};
